
const Loader = () =>{
    
    return(
        <>
            <button className="btn loading text-xl">loading</button>
        </>
    )
};

export default Loader;